var map = {
	"./af/Competency.json": 87038,
	"./af/Dimension.json": 98113,
	"./af/Interview.json": 88106,
	"./af/InterviewQuestion.json": 59250,
	"./af/Keyword.json": 16410,
	"./af/Question.json": 25551,
	"./af/SubCompetency.json": 71914,
	"./af/Tip.json": 9612,
	"./af/auth.json": 77857,
	"./af/common.json": 75462,
	"./af/login.json": 96,
	"./af/menu.json": 97716,
	"./af/register.json": 27050,
	"./af/welcome.json": 56389,
	"./en/App.json": 12374,
	"./en/Competency.json": 82186,
	"./en/Dimension.json": 95109,
	"./en/Interview.json": 20958,
	"./en/InterviewQuestion.json": 41710,
	"./en/Keyword.json": 89326,
	"./en/Question.json": 90419,
	"./en/Sophia.json": 36387,
	"./en/SubCompetency.json": 23990,
	"./en/Tip.json": 81288,
	"./en/auth.json": 15021,
	"./en/common.json": 79802,
	"./en/login.json": 30788,
	"./en/menu.json": 32048,
	"./en/register.json": 38806,
	"./en/welcome.json": 81097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5432;